(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-budtenders"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousel = document.querySelector('[data-budtender-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('.budtender-carousel__track');
    const slides = carousel.querySelectorAll('[data-slide]');
    const prevBtn = document.querySelector('[data-nav="prev"]');
    const nextBtn = document.querySelector('[data-nav="next"]');

    if (!track || slides.length === 0) return;

    // Update navigation button states
    function updateNavButtons() {
      if (!prevBtn || !nextBtn) return;

      const scrollLeft = carousel.scrollLeft;
      const scrollWidth = carousel.scrollWidth;
      const clientWidth = carousel.clientWidth;

      prevBtn.disabled = scrollLeft <= 0;
      nextBtn.disabled = scrollLeft >= scrollWidth - clientWidth - 10;
    }

    // Navigation button handlers
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const slideWidth = slides[0]?.offsetWidth || 275;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        carousel.scrollBy({
          left: -(slideWidth + gap),
          behavior: 'smooth',
        });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const slideWidth = slides[0]?.offsetWidth || 275;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        carousel.scrollBy({
          left: slideWidth + gap,
          behavior: 'smooth',
        });
      });
    }

    // Initialize carousel to start on middle slide
    function initializeCarousel() {
      if (slides.length === 0) return;

      const slideCount = slides.length;
      const carouselRect = carousel.getBoundingClientRect();

      if (slideCount === 1) {
        // If only one slide, center it
        const slide = slides[0];
        const slideRect = slide.getBoundingClientRect();
        const scrollLeft = slide.offsetLeft - carouselRect.width / 2 + slideRect.width / 2;
        carousel.scrollTo({
          left: scrollLeft,
          behavior: 'auto',
        });
      } else if (slideCount % 2 === 1) {
        // For odd number of slides, center the middle slide
        const middleIndex = Math.floor(slideCount / 2);
        const middleSlide = slides[middleIndex];
        if (middleSlide) {
          const slideRect = middleSlide.getBoundingClientRect();
          const scrollLeft = middleSlide.offsetLeft - carouselRect.width / 2 + slideRect.width / 2;
          carousel.scrollTo({
            left: scrollLeft,
            behavior: 'auto',
          });
        }
      } else {
        // For even number of slides, center between the two middle slides
        const middleIndex1 = slideCount / 2 - 1;
        const middleIndex2 = slideCount / 2;
        const slide1 = slides[middleIndex1];
        const slide2 = slides[middleIndex2];
        if (slide1 && slide2) {
          const slide1Rect = slide1.getBoundingClientRect();
          const slide2Rect = slide2.getBoundingClientRect();
          const centerPoint = (slide1.offsetLeft + slide1Rect.width + slide2.offsetLeft) / 2;
          const scrollLeft = centerPoint - carouselRect.width / 2;
          carousel.scrollTo({
            left: scrollLeft,
            behavior: 'auto',
          });
        }
      }
    }

    // Update buttons on scroll
    carousel.addEventListener('scroll', updateNavButtons);
    window.addEventListener('resize', () => {
      updateNavButtons();
      setTimeout(initializeCarousel, 100);
    });

    // Initial button state and carousel positioning
    updateNavButtons();
    setTimeout(initializeCarousel, 100);

    // Drag-to-scroll functionality
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;

    carousel.addEventListener('mousedown', (e) => {
      e.preventDefault();
      isDown = true;
      isDragging = false;
      carousel.style.cursor = 'grabbing';
      startX = e.pageX;
      scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener('mouseleave', () => {
      if (isDown) {
        isDown = false;
        carousel.style.cursor = 'grab';
        isDragging = false;
      }
    });

    carousel.addEventListener('mouseup', () => {
      if (isDown) {
        isDown = false;
        carousel.style.cursor = 'grab';
        isDragging = false;
        updateNavButtons();
      }
    });

    carousel.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      isDragging = true;
      const x = e.pageX;
      const walk = (x - startX) * 2;
      carousel.scrollLeft = scrollLeft - walk;
    });

    // Touch support
    let touchStartX = 0;
    let touchScrollLeft = 0;

    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].pageX;
      touchScrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener('touchmove', (e) => {
      if (!touchStartX) return;
      const x = e.touches[0].pageX;
      const walk = (x - touchStartX) * 2;
      carousel.scrollLeft = touchScrollLeft - walk;
    });

    carousel.addEventListener('touchend', () => {
      updateNavButtons();
      touchStartX = 0;
    });

    // Snap to center on scroll end
    let scrollTimeout;
    carousel.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (!isDown && !touchStartX) {
          const carouselRect = carousel.getBoundingClientRect();
          const carouselCenter = carouselRect.left + carouselRect.width / 2;
          let closestSlide = null;
          let closestDistance = Infinity;

          slides.forEach((slide) => {
            const slideRect = slide.getBoundingClientRect();
            const slideCenter = slideRect.left + slideRect.width / 2;
            const distance = Math.abs(carouselCenter - slideCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestSlide = slide;
            }
          });

          if (closestSlide) {
            const slideRect = closestSlide.getBoundingClientRect();
            const scrollLeft = closestSlide.offsetLeft - carouselRect.width / 2 + slideRect.width / 2;

            carousel.scrollTo({
              left: scrollLeft,
              behavior: 'smooth',
            });
          }
        }
      }, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousel = document.querySelector('[data-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('[data-slide]');
    if (!slides.length) return;

    var isDown = false;
    var startX, scrollStart, lastX, lastTime, velX, rafId, dragged;

    function onMouseDown(e) {
      e.preventDefault();
      isDown = true;
      dragged = false;
      velX = 0;
      startX = e.pageX;
      lastX = e.pageX;
      lastTime = Date.now();
      scrollStart = carousel.scrollLeft;
      carousel.style.cursor = 'grabbing';
      carousel.style.scrollSnapType = 'none';
      if (rafId) cancelAnimationFrame(rafId);
    }

    function onMouseMove(e) {
      if (!isDown) return;
      e.preventDefault();
      dragged = true;
      var x = e.pageX;
      var now = Date.now();
      var dt = now - lastTime;
      if (dt > 0) velX = (lastX - x) / dt;
      lastX = x;
      lastTime = now;
      carousel.scrollLeft = scrollStart - (x - startX);
    }

    function release() {
      if (!isDown) return;
      isDown = false;
      carousel.style.cursor = 'grab';

      if (!dragged) {
        carousel.style.scrollSnapType = 'x mandatory';
        return;
      }

      var momentum = velX * 800;
      var decay = 0.95;

      function coast() {
        if (Math.abs(momentum) < 1) {
          carousel.style.scrollSnapType = 'x mandatory';
          return;
        }
        carousel.scrollLeft += momentum * 0.016;
        momentum *= decay;
        rafId = requestAnimationFrame(coast);
      }
      coast();
    }

    carousel.addEventListener('mousedown', onMouseDown);
    carousel.addEventListener('mousemove', onMouseMove);
    carousel.addEventListener('mouseup', release);
    carousel.addEventListener('mouseleave', release);

    carousel.addEventListener(
      'click',
      function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        }
      },
      true
    );

    function initializeCarousel() {
      var count = slides.length;
      if (!count) return;
      var idx = count % 2 === 0 ? count / 2 - 1 : Math.floor(count / 2);
      var target = slides[idx];
      if (!target) return;
      var rect = target.getBoundingClientRect();
      var cRect = carousel.getBoundingClientRect();
      carousel.scrollTo({ left: target.offsetLeft - cRect.width / 2 + rect.width / 2, behavior: 'auto' });
    }

    setTimeout(initializeCarousel, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.instagram-section');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var carousel = section.querySelector('[data-carousel]');
      if (!carousel) return;

      var slides = carousel.querySelectorAll('[data-slide]');
      if (!slides.length) return;

      var isDown = false;
      var startX, scrollStart, lastX, lastTime, velX, rafId, dragged;

      function onMouseDown(e) {
        e.preventDefault();
        isDown = true;
        dragged = false;
        velX = 0;
        startX = e.pageX;
        lastX = e.pageX;
        lastTime = Date.now();
        scrollStart = carousel.scrollLeft;
        carousel.style.cursor = 'grabbing';
        carousel.style.scrollSnapType = 'none';
        if (rafId) cancelAnimationFrame(rafId);
      }

      function onMouseMove(e) {
        if (!isDown) return;
        e.preventDefault();
        dragged = true;
        var x = e.pageX;
        var now = Date.now();
        var dt = now - lastTime;
        if (dt > 0) velX = (lastX - x) / dt;
        lastX = x;
        lastTime = now;
        carousel.scrollLeft = scrollStart - (x - startX);
      }

      function release() {
        if (!isDown) return;
        isDown = false;
        carousel.style.cursor = 'grab';

        if (!dragged) {
          carousel.style.scrollSnapType = 'x mandatory';
          return;
        }

        var momentum = velX * 800;
        var decay = 0.95;

        function coast() {
          if (Math.abs(momentum) < 1) {
            carousel.style.scrollSnapType = 'x mandatory';
            return;
          }
          carousel.scrollLeft += momentum * 0.016;
          momentum *= decay;
          rafId = requestAnimationFrame(coast);
        }
        coast();
      }

      carousel.addEventListener('mousedown', onMouseDown);
      carousel.addEventListener('mousemove', onMouseMove);
      carousel.addEventListener('mouseup', release);
      carousel.addEventListener('mouseleave', release);

      carousel.addEventListener(
        'click',
        function (e) {
          if (dragged) {
            e.preventDefault();
            e.stopPropagation();
            dragged = false;
          }
        },
        true
      );

      function initializeCarousel() {
        var count = slides.length;
        if (!count) return;
        var idx = count % 2 === 0 ? count / 2 - 1 : Math.floor(count / 2);
        var target = slides[idx];
        if (!target) return;
        var rect = target.getBoundingClientRect();
        var cRect = carousel.getBoundingClientRect();
        carousel.scrollTo({ left: target.offsetLeft - cRect.width / 2 + rect.width / 2, behavior: 'auto' });
      }

      setTimeout(initializeCarousel, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
